import { render, staticRenderFns } from "./Dibble.vue?vue&type=template&id=28bf872c&scoped=true"
import script from "./Dibble.vue?vue&type=script&lang=js"
export * from "./Dibble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf872c",
  null
  
)

export default component.exports